import { withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96c790e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "left-content" }
const _hoisted_3 = { class: "line-name-wrapper" }
const _hoisted_4 = { class: "name-chip-wrapper" }
const _hoisted_5 = { class: "line-text" }
const _hoisted_6 = { class: "line-name" }
const _hoisted_7 = {
  key: 0,
  class: "bus-stop-time"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "line-info_wrapper",
    role: "link",
    tabindex: "0",
    "aria-label": `노선 상세: ${$setup.useGetLineRouteName(
      $props.lineInfo.lineTypeCode,
      $props.lineInfo.routeName,
      $props.lineInfo.lineNum
    )}`
  }, [
    ($props.shouldShowCheckBox)
      ? (_openBlock(), _createBlock($setup["CheckboxInput"], {
          key: 0,
          class: "checkbox-input-wrapper",
          value: $setup.checked,
          disabled: $setup.disabledCheckBox,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ($setup.emitOnChangedCheck($props.lineInfo.id)))
        }, null, 8 /* PROPS */, ["value", "disabled"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["LineSetTypeChip"], {
          lineTypeCode: $props.lineInfo.lineTypeCode,
          lineTypeName: $props.lineInfo.lineTypeName,
          lineTurns: $props.lineInfo.turns
        }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName", "lineTurns"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString($setup.useGetLineRouteName(
                  $props.lineInfo.lineTypeCode,
                  $props.lineInfo.routeName,
                  $props.lineInfo.lineNum
                )), 1 /* TEXT */),
            ($setup.busStopTimes.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.busStopTimes), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.shouldShowBookChip)
            ? (_openBlock(), _createBlock($setup["BookChip"], { key: 0 }))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}